import React, { createContext, useContext, useState, useMemo } from 'react';
import { subscriptionStatus } from '../data';

export interface ProviderInfo {
  organization: {
    logoUrl: string;
    name: string;
    subscriptionStatus: subscriptionStatus;
  };
  providers: [
    {
      name: string;
    }
  ];
  status: string; // patient status
}

interface ProviderInfoContextValue {
  providerInfo: ProviderInfo | null;
  setProviderInfo: (info: ProviderInfo | null) => void;
}

const ProviderInfoContext = createContext<ProviderInfoContextValue>({
  providerInfo: null,
  setProviderInfo: () => {} // Initial empty function
});

export const ProviderInfoProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [providerInfo, setProviderInfo] = useState<ProviderInfo | null>(null);

  const value = useMemo(
    () => ({ providerInfo, setProviderInfo }),
    [providerInfo]
  );

  return (
    <ProviderInfoContext.Provider value={value}>
      {children}
    </ProviderInfoContext.Provider>
  );
};

export const useProviderInfo = () => useContext(ProviderInfoContext);
